/**
 * Printed Decor — Volume Tiers live highlight
 *
 * Counts the quantity of cart items belonging to this block's eligible
 * collection and highlights the tier the shopper currently qualifies for.
 * Reads an eligible-product-id list rendered into the block's data attribute
 * at page load — no runtime product fetches.
 */
(function () {
  'use strict';

  function parseIds(str) {
    if (!str) return {};
    var out = {};
    str.split(',').forEach(function (id) {
      id = id.trim();
      if (id) out[id] = true;
    });
    return out;
  }

  function countEligible(cart, eligibleSet) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (eligibleSet[String(item.product_id)]) total += item.quantity;
    });
    return total;
  }

  function pickActive(tiers, count) {
    var active = null;
    tiers.forEach(function (t) {
      if (count >= t.qty && (!active || t.qty > active.qty)) active = t;
    });
    return active;
  }

  function pickNext(tiers, count) {
    var next = null;
    tiers.forEach(function (t) {
      if (count < t.qty && (!next || t.qty < next.qty)) next = t;
    });
    return next;
  }

  function render(wrap, count) {
    var tiersEl = wrap.querySelector('[data-pd-vt-tiers]');
    if (!tiersEl) return;
    var tiers;
    try { tiers = JSON.parse(tiersEl.textContent); }
    catch (e) { return; }
    if (!Array.isArray(tiers) || !tiers.length) return;
    tiers.sort(function (a, b) { return a.qty - b.qty; });

    var active = pickActive(tiers, count);
    var next = pickNext(tiers, count);

    wrap.querySelectorAll('[data-pd-vt-card]').forEach(function (card) {
      var qty = Number(card.dataset.qty);
      var isActive = !!(active && qty === active.qty);
      card.classList.toggle('pd-volume-tiers__card--active', isActive);
      var pill = card.querySelector('.pd-volume-tiers__active-label');
      if (pill) pill.hidden = !isActive;
    });

    var progress = wrap.querySelector('[data-pd-vt-progress]');
    var subtitle = wrap.querySelector('[data-pd-vt-subtitle]');
    if (!progress) return;

    function hideProgress() {
      progress.dataset.shown = 'false';
      progress.hidden = true;
      if (subtitle) subtitle.hidden = false;
    }

    function showProgress(html) {
      progress.innerHTML = html;
      progress.hidden = false;
      if (subtitle) subtitle.hidden = true;
      // Trigger fade-in on next frame so the opacity transition runs
      requestAnimationFrame(function () {
        progress.dataset.shown = 'true';
      });
    }

    if (count === 0) { hideProgress(); return; }

    if (next) {
      if (active) {
        showProgress('You have <strong>' + count + '</strong> in your cart — saving <strong>' +
          active.pct + '%</strong>. Add <strong>' + (next.qty - count) + '</strong> more to reach <strong>' + next.pct + '%</strong>.');
      } else {
        showProgress('You have <strong>' + count + '</strong> in your cart — add <strong>' + (next.qty - count) +
          '</strong> more to unlock <strong>' + next.pct + '%</strong> off.');
      }
    } else if (active) {
      showProgress("You're saving <strong>" + active.pct + '%</strong> with <strong>' + count +
        '</strong> in your cart. Nice one.');
    } else {
      hideProgress();
    }
  }

  function updateFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var wraps = document.querySelectorAll('[data-pd-volume-tiers]');
    if (!wraps.length) return;
    wraps.forEach(function (w) {
      var set = parseIds(w.dataset.eligibleProductIds || '');
      render(w, countEligible(cart, set));
    });
  }

  function fetchAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(updateFromCart)
      .catch(function () { /* silent */ });
  }

  function onCartUpdate(event) {
    if (event && event.detail && event.detail.resource && Array.isArray(event.detail.resource.items)) {
      updateFromCart(event.detail.resource);
    } else {
      fetchAndUpdate();
    }
  }

  function init() {
    fetchAndUpdate();
    document.addEventListener('cart:update', onCartUpdate);
    document.addEventListener('cart:refresh', onCartUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
